/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * inbound = a text the user sent us; outbound = an SMS notification we sent
 */
export type SmsTimelineMessageDirection =
  (typeof SmsTimelineMessageDirection)[keyof typeof SmsTimelineMessageDirection];

export const SmsTimelineMessageDirection = {
  inbound: "inbound",
  outbound: "outbound",
} as const;
